import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Homepage
      "Book Teaching at JCP": "Book Teaching at JCP",
      "Experience world-class training": "Experience world-class training with champion riders",
      "World-class training": "World-class training for every rider and every level. Renowned for exceptional teaching skills with a philosophy grounded in equality, respect, and inclusion.",
      "Rising star": "Rising star in Scandinavian equestrian sports. Teaching with clarity, energy, and modern perspective. Join for in-person sessions every Tuesday.",
      "Learn more": "Book Lessons",
      "Home": "Home",
      
      // Julie Options Page
      "Choose Your Training Type": "Choose Your Training Type",
      "Select how you'd like to train": "Select how you'd like to train with Julie Christiansen",
      "Pivo Live Lesson": "Pivo Live Lesson",
      "Remote Teaching - Wednesdays": "Remote Teaching - Wednesdays",
      "Pivo description": "Personal online training sessions via video call. Learn from anywhere with Julie guiding you remotely. Perfect for riders who want world-class coaching from their own location.",
      "On-Site Training": "Live in Heiden",
      "New address note": "(new address)",
      "Live at JC-P Facility - Wednesdays": "Wednesdays",
      "On-Site description": "Train in person at our beautiful, bright indoor arena. Direct hands-on instruction with Julie in a professional training environment.",
      "Price per lesson": "Price: €{{price}} per lesson",
      "Available daytime and evening": "Available: Wednesdays - Daytime and evening",
      "Greven session info": "Info: Riding lessons are 40 minutes.",
      "Weekend Clinic": "Weekend Course",
      "At Your Stable or Club": "At Your Stable or Club",
      "Weekend description": "Book Julie for an intensive 2-4 day course at your own facility. Maximum 10 riders. Tailored program focusing on horse-and-rider partnerships.",
      "Weekend Course in Greven": "Weekend Course",
      "Here in Greven": "Here in Heiden",
      "Weekend Greven description": "We also occasionally offer 2-3 day courses at our stable in Heiden. See available dates for 2026.",
      "Theorie Clinic": "Theory Clinic",
      "Theoretical Workshops - Online or On-Site": "Theoretical Workshops - Online or On-Site",
      "Theorie Clinic description": "Book a theoretical clinic on a topic of your choice. Online evening sessions or in-person at your stable or club.",
      
      // Booking Pages
      "Pivo Live Lesson with Julie": "Pivo Live Lesson with Julie",
      "Remote teaching - Available Wednesdays": "Remote teaching - Available Wednesdays",
      "On-Site Training at JC-P": "Teaching with Julie",
      "Train live in our beautiful indoor arena - Wednesdays": "Live sessions in Heiden - Every Wednesday",
      "Teaching with Óskar": "Teaching with Óskar",
      "Live sessions at JC-P - Every Tuesday": "Live sessions in Heiden - Every Tuesday",
      "Weekend Clinic with Julie": "Weekend Course with Julie",
      "Host Julie at your stable or club for an intensive clinic": "Book Julie at your stable or club for an intensive course",
      
      // Calendar
      "Colored dates are available for booking": "Colored dates are available for booking",
      "Select a date and time": "Select a date and time",
      
      // Information Sections
      "About Pivo Live Lessons": "About Pivo Live Lessons",
      "About On-Site Training": "About On-Site Training",
      "About Óskar Erik Kristjánsson": "About Óskar Erik Kristjánsson",
      "About Weekend Clinics": "About Weekend Courses",
      
      // Pivo Info
      "Train remotely with Julie": "Train remotely with Julie Christiansen through live video sessions. Using Pivo technology, Julie can watch and guide your training in real-time from anywhere in the world.",
      "About Julie": "About Julie:",
      "3x World Champion": "3x World Champion",
      "3x Nordic Champion": "3x Nordic Champion",
      "25x Danish Champion": "26x Danish Champion",
      "Renowned for exceptional teaching": "Renowned for exceptional teaching skills for all levels",
      "Sessions last 60 minutes": "Sessions last 40 minutes and are tailored to your individual goals and skill level.",
      "Oscar price": "Price: €30 per lesson",
      "Online payment required": "(Online payment required)",
      "Pay on-site": "(Pay on-site)",
      "Available Wednesdays": "Available: Wednesdays",
      "Available Tuesday afternoons": "Available: Tuesday afternoons and evenings",
      
      // On-Site Info
      "Train in person with Julie": "Train in person with Julie Christiansen at our beautiful, bright indoor arena at JC-P. Experience direct hands-on instruction in a professional training environment.",
      "Exceptional didactic skills": "Exceptional didactic skills for all levels from beginners to top competitors",
      "Julie's philosophy": "Julie's philosophy is grounded in equality, respect, and inclusion. Every student receives thoughtful attention regardless of background or goals. Sessions are tailored to your individual horse-and-rider partnership.",
      
      // Oscar Info
      "Rising star in Scandinavian": "Rising star in Scandinavian equestrian sports",
      "Championships": "Championships:",
      "2x Nordic Champion": "2x Nordic Champion",
      "Winner of German Youth Championships": "3x Winner of German Youth Championships (DJIM)",
      "10x Danish Champion": "10x Danish Champion",
      "Oscar teaches with clarity": "Óskar teaches with clarity, energy, and a modern perspective. He brings competitive experience and fresh motivation to every lesson, making him one of the most exciting young talents in Scandinavian equestrian training.",
      "Join Oscar for sessions": "Join Óskar for personal riding lessons in our beautiful, bright indoor arena. The riding lessons are tailored to your individual goals and skill level.",
      "Oscar session info": "Info: Riding lessons are 40 minutes.",
      
      // Weekend Clinic Info
      "Julie Christiansen - accomplished": "Julie Christiansen - one of Scandinavia's most accomplished riders and trainers:",
      "Host Julie intensive": "Book Julie for an intensive 2-4 day course directly at your own stable or club. Her warm, passionate approach creates a motivating space where true progress happens.",
      "Clinic Details": "Course Details:",
      "Duration minimum 2 days": "Duration: Minimum 2 days, up to 4 consecutive days",
      "Maximum 10 riders": "Maximum participants: 10 riders",
      "Price per day": "Price: €{{price}} per day",
      "Includes travel costs": "Includes: Training, travel costs, flight costs",
      "Additional accommodation": "Additional: Accommodation and meals for Julie",
      "Important": "Important:",
      "Book minimum 2 days": "Book minimum 2 days (each day must be booked)",
      "Cancellation 1 month": "Cancellation possible up to 1 month before course start",
      "Program tailored": "Program can be tailored to your group's needs",
      "After submitting request": "After submitting your request, we will contact you to confirm availability and discuss the specific program and arrangements.",
      
      // Form
      "Select Date": "Select Date",
      "Available Times": "Available Times",
      "Select date in calendar": "Please select a date in the calendar",
      "No available time slots": "No available time slots for this date",
      "Your Information": "Your Information",
      "Full Name": "Full Name",
      "Email": "Email",
      "Phone": "Phone",
      "Confirm Booking": "Confirm Booking",
      "Book & Pay Online": "Book & Pay Online",
      "Processing": "Processing...",
      "Submitting": "Submitting...",
      
      // Weekend Form
      "Number of Days": "Number of Days (Minimum 2)",
      "Days": "Days",
      "Plus accommodation": "+ Accommodation & meals",
      "Total": "Total: €{total}",
      "Stable/Club Name": "Stable/Club Name & Location",
      "Where clinic held": "Where will the course be held?",
      "Request Weekend Clinic": "Request Weekend Course",
      "Request only": "This is a request only. We will contact you to confirm dates and finalize details.",
      
      // External Weekend Course Page
      "External Weekend Courses": "External Weekend Courses",
      "Host Julie at your stable": "Host Julie at your stable or club for an intensive course",
      "Date flexibility notice": "Important: Date Flexibility",
      "Date flexibility description": "We try to accommodate your preferred dates, but cannot guarantee them. That's why it's good to provide an alternative date.",
      "About Weekend Courses": "About Weekend Courses",
      "Weekend course intro": "A fantastic opportunity to learn from one of the best in the sport in a private and focused setting.",
      "Course Details": "Course Details",
      "Duration": "Duration",
      "Min 2 max 4 days": "Minimum 2, Maximum 4 days",
      "Maximum": "Maximum",
      "riders": "riders",
      "Price per day": "Price per day",
      "includes travel": "includes travel costs",
      "Extra costs": "Extra costs",
      "Accommodation and meals": "Accommodation + meals",
      "Request Course": "Request Course",
      "Number of Days": "Number of Days",
      "You must be logged in": "You must be logged in",
      "Please fill in name/stable and address": "Please fill in name/stable and address",
      "Please select a date period": "Please select a date period",
      "Please select which days": "Please select which days of the period",
      "Request sent successfully": "Request sent! We will contact you soon with possible dates.",
      "Could not send request": "Could not send request",
      "Name/Stable/Club": "Name/Stable/Club",
      "Your name, stable or club": "Your name, stable or club",
      "Address": "Address",
      "Course location address": "Address of course location",
      "Preferred Date": "Preferred Date",
      "Loading dates": "Loading dates",
      "No dates available": "No dates available at the moment. Please check back later or contact us directly.",
      "Which days": "Which days of the period?",
      "Which days for alternative": "Which days for alternative date?",
      "First 2 days": "First 2 days",
      "Last 2 days": "Last 2 days",
      "First 3 days": "First 3 days",
      "Last 3 days": "Last 3 days",
      "All 4 days": "All 4 days",
      "Alternative Date": "Alternative Date",
      "optional": "optional",
      "No alternative": "No alternative",
      "Course Type": "Course Type",
      "Single Course": "Single Course",
      "One-time event": "One-time event",
      "Course Series": "Course Series",
      "Multiple throughout year": "Multiple courses throughout the year",
      "Additional Information": "Additional Information",
      "Additional info description": "Share any special requests, number of participants, or other relevant information.",
      "Additional info placeholder": "Any special requests, number of participants, or other information...",
      "Not enough days available": "Not enough days available for your selection",
      "No day options available for this period": "No day options available for this period",
      "Try selecting fewer days or another period": "Try selecting fewer days or another period",
      "Only available": "Only available",
      "days available": "days available",
      "Sending": "Sending",
      "Send Request": "Send Request",
      
      // Weekend Greven Page
      "Weekend Course in Greven with Julie": "Weekend Course in Heiden with Julie",
      "Join us for intensive courses at our stable": "Join us for intensive courses at our stable",
      "About Weekend Courses in Greven": "About Weekend Courses in Heiden",
      "Weekend Greven intensive text": "We occasionally offer intensive 2-3 day courses directly at our stable in Heiden. Her warm, passionate approach creates a motivating space where true progress happens.",
      "Duration 2-3 days": "Duration: 2-3 days",
      "Location": "Location",
      "Our stable in Greven": "Our stable in Heiden",
      "Specific dates available for 2026": "Specific dates available for 2026",
      "Select from available dates": "Select from available dates",
      "Request Course in Greven": "Request Course in Heiden",
      "Weekend Greven request submitted": "Course request submitted! We will contact you to confirm availability and discuss details.",
      
      // Theorie Clinic Page
      "Theorie Clinic with Julie": "Theory Clinic with Julie",
      "Book theoretical workshops on equestrian topics": "Book theoretical workshops on equestrian topics",
      "About Theorie Clinics": "About Theory Clinics",
      "Theorie Clinic experience text": "With extensive experience in conducting theoretical clinics, I offer workshops on various equestrian topics. I have held numerous live clinics and major presentations in many different countries, both online and in person.",
      "Clinic Options": "Clinic Options",
      "Online evening sessions": "Online day or evening sessions",
      "On-site workshops at your stable or club": "On-site workshops at your stable or club",
      "Flexible duration": "Flexible duration",
      "Evening, day or multi-day": "Evening, day or multi-day",
      "Topics of your choice": "Topics of your choice",
      "Theorie Clinic details text": "Choose a topic that interests you, and I will create a tailored clinic. Whether it's an online evening session or in person at your location - I adapt to your needs.",
      "Let us know interested": "Let us know what you're interested in.",
      "Request heading": "Request",
      "Select dates that suit": "Select one or more dates that suit you.",
      "Select your preferred date": "Select your preferred date",
      "Clinic Type": "Clinic Type",
      "Online": "Online",
      "On-Site": "On-Site",
      "Preferred Duration": "Preferred Duration",
      "Evening": "Evening",
      "Full Day": "Full Day",
      "Multi-Day": "Multi-Day",
      "Topic / Theme": "Topic / Theme",
      "What topic would you like to cover?": "What topic would you like to cover?",
      "Stable/Club name and location": "Stable/Club name and location",
      "Additional Notes": "Additional Notes",
      "Any special requests or questions": "Any special requests or questions",
      "Request Theorie Clinic": "Request Theory Clinic",
      "Theorie Clinic request submitted": "Theory Clinic request submitted! We will contact you to discuss details.",
      "Please select a date": "Please select a date",
      "Please fill all required fields": "Please fill all required fields",
      "Please provide location for on-site clinic": "Please provide location for on-site clinic",
      
      // Messages
      "Please select date time": "Please select a date and time",
      "Please fill all fields": "Please fill in all fields",
      "Booking confirmed message": "Booking confirmed! Pay in person at your session.",
      "Weekend request submitted": "Weekend course request submitted! We will contact you to confirm availability and discuss details.",
      "Failed to create booking": "Failed to create booking",
      "Failed to submit request": "Failed to submit request",
      "Please select start date": "Please select a start date",
      
      // Booking confirmation
      "Confirm booking": "Confirm booking",
      "Date": "Date",
      "Time": "Time",
      "Confirm": "Confirm",
      "Booking confirmed!": "Booking confirmed!",
      
      // Dashboard - Payment Info
      "Payment Information": "Payment Information",
      "Please transfer the amount before your lesson. Use your name as payment reference.": "Please transfer the amount before your lesson. Use your name as payment reference.",
      
      // User approval
      "Your account is awaiting approval": "Your account is awaiting approval. Please contact admin.",
      "Account pending approval": "Your account is pending approval. You will be able to book lessons once approved by an administrator.",
      "Account Awaiting Approval": "Account Awaiting Approval",
      "Your account is currently awaiting admin approval. You will be able to book lessons once your account has been approved. We will notify you by email when your account is ready.": "Your account is currently awaiting admin approval. You will be able to book lessons once your account has been approved. We will notify you by email when your account is ready.",
      
      // Backup page
      "Database Backup": "Database Backup",
      "Download or restore your database": "Download or restore your database",
      "Back to Admin": "Back to Admin",
      "Download Backup": "Download Backup",
      "Download a complete backup of all your data as a JSON file": "Download a complete backup of all your data as a JSON file",
      "Backup includes": "Backup includes",
      "Users": "Users",
      "Bookings": "Bookings",
      "Availability": "Availability",
      "Weekend Courses": "Weekend Courses",
      "Theory Clinics": "Theory Clinics",
      "Settings": "Settings",
      "Admin Events": "Admin Events",
      "Downloading...": "Downloading...",
      "Backup downloaded successfully": "Backup downloaded successfully",
      "Failed to download backup": "Failed to download backup",
      "Restore Backup": "Restore Backup",
      "Upload a backup file to restore your data": "Upload a backup file to restore your data",
      "Note": "Note",
      "Restore will only add missing data. Existing records will not be overwritten or deleted.": "Restore will only add missing data. Existing records will not be overwritten or deleted.",
      "Select Backup File": "Select Backup File",
      "Restoring...": "Restoring...",
      "Please select a JSON file": "Please select a JSON file",
      "Invalid backup file format": "Invalid backup file format",
      "Invalid JSON file": "Invalid JSON file",
      "Failed to restore backup": "Failed to restore backup",
      "Restore completed successfully": "Restore completed successfully",
      "Restore completed": "Restore completed",
      "Backup date": "Backup date",
      "Restored records": "Restored records",
      "Yes": "Yes",
      "No": "No",
      "Loading...": "Loading...",
      "Automatic Backups": "Automatic Backups",
      "Daily backups at 15:00 - kept for 7 days": "Daily backups at 15:00 - kept for 7 days",
      "Refresh": "Refresh",
      "No automatic backups yet": "No automatic backups yet",
      "First backup will be created at 15:00": "First backup will be created at 15:00",
      "Latest": "Latest",
      "Download": "Download",
      
      // Customer Dashboard
      "Welcome back": "Welcome back",
      "My Bookings": "My Bookings",
      "Profile": "Profile",
      "Payment Methods": "Payment Methods",
      "Upcoming": "Upcoming",
      "Past": "Past",
      "All": "All",
      "Loading bookings...": "Loading bookings...",
      "You don't have any upcoming bookings.": "You don't have any upcoming bookings.",
      "You don't have any past bookings yet.": "You don't have any past bookings yet.",
      "You don't have any bookings yet.": "You don't have any bookings yet.",
      "Book a Lesson": "Book a Lesson",
      "Cancelled": "Cancelled",
      "Paid": "Paid",
      "Payment Pending": "Payment Pending",
      "Pay on arrival": "Pay on arrival",
      "View Receipt": "View Receipt",
      "Cancel Booking": "Cancel Booking",
      "Are you sure you want to cancel this booking?": "Are you sure you want to cancel this booking?",
      "Booking cancelled successfully": "Booking cancelled successfully",
      "Failed to cancel booking": "Failed to cancel booking",
      "Failed to load bookings": "Failed to load bookings",
      "Failed to load receipt": "Failed to load receipt",
      "Profile Settings": "Profile Settings",
      "Email cannot be changed": "Email cannot be changed",
      "Name": "Name",
      "Saving...": "Saving...",
      "Save Changes": "Save Changes",
      "Profile updated successfully": "Profile updated successfully",
      "Failed to update profile": "Failed to update profile",
      
      // Get as App tab
      "Get as App": "Get as App",
      "Add JCP Lessons to your home screen": "Add JCP Lessons to your home screen",
      "app_description": "Instead of opening the website every time, you can add JCP Lessons to your phone as an app. This gives you quick access to book lessons directly from your home screen.",
      "How to install on iPhone": "How to install on iPhone",
      "Step 1": "Step 1",
      "Step 2": "Step 2",
      "Step 3": "Step 3",
      "Step 4": "Step 4",
      "Open the website in Safari on your iPhone": "Open the website in Safari on your iPhone",
      "Tap the Share button": "Tap the Share button",
      "Select \"Add to Home Screen\"": "Select \"Add to Home Screen\"",
      "The icon will appear with \"JCP LESSONS\" text": "The icon will appear with \"JCP LESSONS\" text",
      "Tap the link and follow the 4 steps above": "Tap the link and follow the 4 steps above",
      "Android users can also add to home screen via Chrome menu": "Android users can also add to home screen via Chrome menu",
      
      // Admin Dashboard
      "Admin Dashboard": "Admin Dashboard",
      "Select an area to manage": "Select an area to manage",
      "Calendar": "Calendar",
      "Plan": "Plan",
      "User Management": "User Management",
      "Service Visibility": "Service Visibility",
      "Backup": "Backup",
      "Upcoming Bookings (7 days)": "Upcoming Bookings (7 days)",
      "bookings": "bookings",
      "No bookings in the next 7 days": "No bookings in the next 7 days",
      "Today": "Today",
      "Tomorrow": "Tomorrow",
      "Send Reminder": "Send Reminder",
      "Reminder": "Reminder",
      "Sending...": "Sending...",
      "Reminder sent to": "Reminder sent to",
      "Could not send reminder": "Could not send reminder",
      "View All Bookings": "View All Bookings",
      
      // Admin Bookings
      "Manage Bookings": "Manage Bookings",
      "Back to Admin Dashboard": "Back to Admin Dashboard",
      "total": "total",
      "awaiting payment": "awaiting payment",
      "No bookings yet.": "No bookings yet.",
      "booking": "booking",
      "Mark as paid?": "Mark as paid?",
      "Mark as paid? (Greven booking will be deleted after payment)": "Mark as paid? (Heiden booking will be deleted after payment)",
      "Booking marked as paid and deleted": "Booking marked as paid and deleted",
      "Booking marked as paid": "Booking marked as paid",
      "Could not update payment": "Could not update payment",
      "Booking cancelled": "Booking cancelled",
      "Could not cancel booking": "Could not cancel booking",
      "Pivo Online": "Pivo Online",
      "Live in Greven": "Live in Heiden",
      
      // Admin Availability
      "Manage Availability": "Manage Availability",
      "Create and manage instructor availability": "Create and manage instructor availability",
      "Add Availability": "Add Availability",
      "No availability slots created yet.": "No availability slots created yet.",
      "Click Add Availability to create new time slots for bookings.": "Click Add Availability to create new time slots for bookings.",
      "date": "date",
      "dates": "dates",
      "slots": "slots",
      "Are you sure you want to delete availability for": "Are you sure you want to delete availability for",
      "Availability deleted": "Availability deleted",
      "Could not delete availability": "Could not delete availability",
      "Copy to next weeks": "Copy to next weeks",
      "Edit": "Edit",
      "Delete": "Delete",
      "date(s) copied!": "date(s) copied!",
      "date(s) skipped (already exists)": "date(s) skipped (already exists)",
      "Could not copy availability": "Could not copy availability"
    }
  },
  da: {
    translation: {
      // Homepage
      "Book Teaching at JCP": "Book undervisning hos JCP",
      "Experience world-class training": "Oplev verdensklasse træning med mesterryttere",
      "World-class training": "Verdensklasse træning for enhver rytter på ethvert niveau. Berømt for exceptionelle undervisningsevner med en filosofi baseret på ligestilling, respekt og inklusion.",
      "Rising star": "Opstigende stjerne i skandinavisk ridesport. Underviser med klarhed, energi og moderne perspektiv. Deltag i personlige sessioner hver tirsdag.",
      "Learn more": "Book Undervisning",
      "Home": "Hjem",
      
      // Julie Options Page
      "Choose Your Training Type": "Vælg din træningstype",
      "Select how you'd like to train": "Vælg hvordan du vil træne med Julie Christiansen",
      "Pivo Live Lesson": "Pivo Live Lektion",
      "Remote Teaching - Wednesdays": "Fjernundervisning - Onsdage",
      "Pivo description": "Personlige online træningssessioner via videoopkald. Lær hvor som helst med Julie der guider dig eksternt. Perfekt for ryttere der ønsker verdensklasse coaching fra deres egen lokation.",
      "On-Site Training": "Live i Heiden",
      "New address note": "(ny adresse)",
      "Live at JC-P Facility - Wednesdays": "Onsdage",
      "On-Site description": "Træn personligt i vores smukke, lyse indendørs ridebane. Direkte praktisk instruktion med Julie i et professionelt træningsmiljø.",
      "Price per lesson": "Pris: €{{price}} pr. lektion",
      "Available daytime and evening": "Tilgængelig: Onsdage - Om dagen og om aftenen",
      "Greven session info": "Info: Ridetimerne varer 40 minutter.",
      "Weekend Clinic": "Weekend Kursus",
      "At Your Stable or Club": "På Din Stald eller Klub",
      "Weekend description": "Book Julie til et intensivt 2-4 dages kursus på dit eget anlæg. Maksimalt 10 ryttere. Tilpasset program med fokus på hest-rytter partnerskaber.",
      "Weekend Course in Greven": "Weekend Kursus",
      "Here in Greven": "Her i Heiden",
      "Weekend Greven description": "Vi tilbyder også lejlighedsvis 2-3 dages kurser i vores stald i Heiden. Se tilgængelige datoer for 2026.",
      "Theorie Clinic": "Teori Clinic",
      "Theoretical Workshops - Online or On-Site": "Teoretiske Workshops - Online eller på Stedet",
      "Theorie Clinic description": "Book en teoretisk clinic om et emne efter dit valg. Online aftentermine eller personligt hos dig i stalden eller klubben.",
      
      // Booking Pages
      "Pivo Live Lesson with Julie": "Pivo Live Lektion med Julie",
      "Remote teaching - Available Wednesdays": "Fjernundervisning - Tilgængelig onsdage",
      "On-Site Training at JC-P": "Undervisning med Julie",
      "Train live in our beautiful indoor arena - Wednesdays": "Live sessioner i Heiden - Hver onsdag",
      "Teaching with Óskar": "Undervisning med Óskar",
      "Live sessions at JC-P - Every Tuesday": "Live sessioner i Heiden - Hver tirsdag",
      "Weekend Clinic with Julie": "Weekend Kursus med Julie",
      "Host Julie at your stable or club for an intensive clinic": "Book Julie på din stald eller klub til et intensivt kursus",
      
      // Calendar
      "Colored dates are available for booking": "Farvede datoer er tilgængelige for booking",
      "Select a date and time": "Vælg dato og tidspunkt",
      
      // Information Sections
      "About Pivo Live Lessons": "Om Pivo Live Lektioner",
      "About On-Site Training": "Om Undervisning på Stedet",
      "About Óskar Erik Kristjánsson": "Om Óskar Erik Kristjánsson",
      "About Weekend Clinics": "Om Weekend Kurser",
      
      // Pivo Info
      "Train remotely with Julie": "Træn eksternt med Julie Christiansen gennem live video sessioner. Ved hjælp af Pivo teknologi kan Julie se og guide din træning i realtid fra hvor som helst i verden.",
      "About Julie": "Om Julie:",
      "3x World Champion": "3x Verdensmester",
      "3x Nordic Champion": "3x Nordisk Mester",
      "25x Danish Champion": "25x Dansk Mester",
      "Renowned for exceptional teaching": "Berømt for exceptionelle undervisningsevner for alle niveauer",
      "Sessions last 60 minutes": "Sessioner varer 40 minutter og er skræddersyet til dine individuelle mål og færdighedsniveau.",
      "Oscar price": "Pris: €30 pr. lektion",
      "Online payment required": "(Online betaling påkrævet)",
      "Pay on-site": "(Betal på stedet)",
      "Available Wednesdays": "Tilgængelig: Onsdage",
      "Available Tuesday afternoons": "Tilgængelig: Tirsdag eftermiddage og aftener",
      
      // On-Site Info
      "Train in person with Julie": "Træn personligt med Julie Christiansen i vores smukke, lyse indendørs ridebane hos JC-P. Oplev direkte praktisk instruktion i et professionelt træningsmiljø.",
      "Exceptional didactic skills": "Exceptionelle didaktiske færdigheder for alle niveauer fra begyndere til topkonkurrenter",
      "Julie's philosophy": "Julies filosofi er baseret på ligestilling, respekt og inklusion. Hver elev modtager omhyggelig opmærksomhed uanset baggrund eller mål. Sessioner er skræddersyet til dit individuelle hest-rytter partnerskab.",
      
      // Oscar Info
      "Rising star in Scandinavian": "Opstigende stjerne i skandinavisk ridesport",
      "Championships": "Mesterskaber:",
      "2x Nordic Champion": "2x Nordisk Mester",
      "Winner of German Youth Championships": "3x Vinder af Tyske Ungdomsmesterskaber (DJIM)",
      "10x Danish Champion": "10x Dansk Mester",
      "Oscar teaches with clarity": "Óskar underviser med klarhed, energi og et moderne perspektiv. Han bringer konkurrenceerfaring og frisk motivation til hver lektion, hvilket gør ham til et af de mest spændende unge talenter i skandinavisk ridetræning.",
      "Join Oscar for sessions": "Deltag i Óskars personlige ridetimer i vores smukke, lyse indendørs ridebane. Ridetimerne er skræddersyet til dine individuelle mål og færdighedsniveau.",
      "Oscar session info": "Info: Ridetimerne varer 40 minutter.",
      
      // Weekend Clinic Info
      "Julie Christiansen - accomplished": "Julie Christiansen - en af Skandinaviens mest erfarne ryttere og trænere:",
      "Host Julie intensive": "Book Julie til et intensivt 2-4 dages kursus direkte på din egen stald eller klub. Hendes varme, passionerede tilgang skaber et motiverende rum hvor ægte fremskridt sker.",
      "Clinic Details": "Kursus Detaljer:",
      "Duration minimum 2 days": "Varighed: Minimum 2 dage, op til 4 på hinanden følgende dage",
      "Maximum 10 riders": "Maksimalt deltagere: 10 ryttere",
      "Price per day": "Pris: €{{price}} pr. dag",
      "Includes travel costs": "Inkluderer: Træning, rejseomkostninger, flyomkostninger",
      "Additional accommodation": "Ekstra: Overnatning og måltider til Julie",
      "Important": "Vigtigt:",
      "Book minimum 2 days": "Book minimum 2 dage (hver dag skal bookes)",
      "Cancellation 1 month": "Afbestilling mulig op til 1 måned før kursus start",
      "Program tailored": "Program kan tilpasses din gruppes behov",
      "After submitting request": "Efter indsendelse af din anmodning vil vi kontakte dig for at bekræfte tilgængelighed og diskutere det specifikke program og arrangementer.",
      
      // Form
      "Select Date": "Vælg Dato",
      "Available Times": "Ledige Tider",
      "Select date in calendar": "Vælg venligst en dato i kalenderen",
      "No available time slots": "Ingen ledige tider for denne dato",
      "Your Information": "Dine Oplysninger",
      "Full Name": "Fulde Navn",
      "Email": "E-mail",
      "Phone": "Telefon",
      "Confirm Booking": "Bekræft Booking",
      "Book & Pay Online": "Book & Betal Online",
      "Processing": "Behandler...",
      "Submitting": "Indsender...",
      
      // Weekend Form
      "Number of Days": "Antal Dage (Minimum 2)",
      "Days": "Dage",
      "Plus accommodation": "+ Overnatning & måltider",
      "Total": "Total: €{total}",
      "Stable/Club Name": "Stald/Klub Navn & Placering",
      "Where clinic held": "Hvor skal kursus afholdes?",
      "Request Weekend Clinic": "Anmod om Weekendkursus",
      "Request only": "Dette er kun en anmodning. Vi kontakter dig for at bekræfte datoer og færdiggøre detaljer.",
      
      // External Weekend Course Page
      "External Weekend Courses": "Weekendkurser Udkørende",
      "Host Julie at your stable": "Host Julie på din stald eller klub til et intensivt kursus",
      "Date flexibility notice": "Vigtigt: Dato Fleksibilitet",
      "Date flexibility description": "Vi prøver at imødekomme dine ønsker ang. dato, men vi kan ikke love at det lykkes. Derfor er det godt at angive en alternativ dato.",
      "About Weekend Courses": "Om Weekendkurser",
      "Weekend course intro": "En fantastisk mulighed for at lære fra en af de bedste i sporten i en privat og fokuseret setting.",
      "Course Details": "Kursusdetaljer",
      "Duration": "Varighed",
      "Min 2 max 4 days": "Minimum 2, Maksimum 4 dage",
      "Maximum": "Maksimum",
      "riders": "ryttere",
      "Price per day": "Pris per dag",
      "includes travel": "inkluderer rejseomkostninger",
      "Extra costs": "Ekstra omkostninger",
      "Accommodation and meals": "Overnatning + forplejning",
      "Request Course": "Forespørg om Kursus",
      "Number of Days": "Antal Dage",
      "You must be logged in": "Du skal være logget ind",
      "Please fill in name/stable and address": "Udfyld venligst navn/stald og adresse",
      "Please select a date period": "Vælg venligst en dato periode",
      "Please select which days": "Vælg venligst hvilke dage i perioden",
      "Request sent successfully": "Anmodning sendt! Vi kontakter dig snart med mulige datoer.",
      "Could not send request": "Kunne ikke sende anmodning",
      "Name/Stable/Club": "Navn/Stald/Klub",
      "Your name, stable or club": "Dit navn, din stald eller klub",
      "Address": "Adresse",
      "Course location address": "Adressen på kursusstedet",
      "Preferred Date": "Ønsket Dato",
      "Loading dates": "Henter datoer",
      "No dates available": "Ingen datoer tilgængelige i øjeblikket. Tjek venligst senere eller kontakt os direkte.",
      "Which days": "Hvilke dage i perioden?",
      "Which days for alternative": "Hvilke dage for alternativ dato?",
      "First 2 days": "Første 2 dage",
      "Last 2 days": "Sidste 2 dage",
      "First 3 days": "Første 3 dage",
      "Last 3 days": "Sidste 3 dage",
      "All 4 days": "Alle 4 dage",
      "Alternative Date": "Alternativ Dato",
      "optional": "valgfrit",
      "No alternative": "Ingen alternativ",
      "Course Type": "Kursustype",
      "Single Course": "Enkeltkursus",
      "One-time event": "Enkelt begivenhed",
      "Course Series": "Kursusrække",
      "Multiple throughout year": "Flere kurser gennem året",
      "Additional Information": "Yderligere Information",
      "Additional info description": "Del eventuelle særlige ønsker, antal deltagere, eller andre relevante oplysninger.",
      "Additional info placeholder": "Særlige ønsker, antal deltagere, eller andre oplysninger...",
      "Not enough days available": "Ikke nok dage til rådighed for dit valg",
      "No day options available for this period": "Ingen dag-muligheder tilgængelige for denne periode",
      "Try selecting fewer days or another period": "Prøv at vælge færre dage eller en anden periode",
      "Only available": "Kun tilgængelig",
      "days available": "dage ledige",
      "Sending": "Sender",
      "Send Request": "Send Anmodning",
      
      // Weekend Greven Page
      "Weekend Course in Greven with Julie": "Weekend Kursus i Heiden med Julie",
      "Join us for intensive courses at our stable": "Deltag i intensive kurser på vores stald",
      "About Weekend Courses in Greven": "Om Weekend Kurser i Heiden",
      "Weekend Greven intensive text": "Vi tilbyder lejlighedsvis intensive 2-3 dages kurser direkte hos os på stalden i Heiden. Hendes varme, passionerede tilgang skaber et motiverende rum hvor ægte fremskridt sker.",
      "Duration 2-3 days": "Varighed: 2-3 dage",
      "Location": "Sted",
      "Our stable in Greven": "Vores stald i Heiden",
      "Specific dates available for 2026": "Specifikke datoer tilgængelige for 2026",
      "Select from available dates": "Vælg fra tilgængelige datoer",
      "Request Course in Greven": "Anmod om Kursus i Heiden",
      "Weekend Greven request submitted": "Kursusanmodning indsendt! Vi kontakter dig for at bekræfte tilgængelighed og diskutere detaljer.",
      
      // Theorie Clinic Page
      "Theorie Clinic with Julie": "Teori Clinic med Julie",
      "Book theoretical workshops on equestrian topics": "Book teoretiske workshops om rideemner",
      "About Theorie Clinics": "Om Teori Clinics",
      "Theorie Clinic experience text": "Med stor erfaring i at holde teoretiske clinics tilbyder jeg workshops om forskellige rideemner. Jeg har holdt talrige live clinics og store foredrag i mange forskellige lande, både online og personligt.",
      "Clinic Options": "Clinic Muligheder",
      "Online evening sessions": "Online dag eller aften tider",
      "On-site workshops at your stable or club": "Workshops på stedet i din stald eller klub",
      "Flexible duration": "Fleksibel varighed",
      "Evening, day or multi-day": "Aften, dag eller flere dage",
      "Topics of your choice": "Emner efter dit valg",
      "Theorie Clinic details text": "Vælg et emne der interesserer dig, og jeg laver en skræddersyet clinic. Uanset om det er online aftentermine eller personligt hos dig - jeg tilpasser mig dine behov.",
      "Let us know interested": "Lad os vide hvad du er interesseret i.",
      "Request heading": "Forespørgsel",
      "Select dates that suit": "Vælg en eller flere datoer som passer dig.",
      "Select your preferred date": "Vælg din foretrukne dato",
      "Clinic Type": "Clinic Type",
      "Online": "Online",
      "On-Site": "På Stedet",
      "Preferred Duration": "Foretrukken Varighed",
      "Evening": "Aften",
      "Full Day": "Hele Dagen",
      "Multi-Day": "Flere Dage",
      "Topic / Theme": "Emne / Tema",
      "What topic would you like to cover?": "Hvilket emne vil du gerne behandle?",
      "Stable/Club name and location": "Stald/Klub navn og placering",
      "Additional Notes": "Yderligere Bemærkninger",
      "Any special requests or questions": "Særlige ønsker eller spørgsmål",
      "Request Theorie Clinic": "Anmod om Teori Clinic",
      "Theorie Clinic request submitted": "Teori Clinic anmodning indsendt! Vi kontakter dig for at diskutere detaljer.",
      "Please select a date": "Vælg venligst en dato",
      "Please fill all required fields": "Udfyld venligst alle påkrævede felter",
      "Please provide location for on-site clinic": "Angiv venligst sted for clinic på stedet",
      
      // Messages
      "Please select date time": "Vælg venligst dato og tidspunkt",
      "Please fill all fields": "Udfyld venligst alle felter",
      "Booking confirmed message": "Booking bekræftet! Betal personligt til din session.",
      "Weekend request submitted": "Weekendkursus anmodning indsendt! Vi kontakter dig for at bekræfte tilgængelighed og diskutere detaljer.",
      "Failed to create booking": "Kunne ikke oprette booking",
      "Failed to submit request": "Kunne ikke indsende anmodning",
      "Please select start date": "Vælg venligst en startdato",
      
      // Booking confirmation
      "Confirm booking": "Bekræft booking",
      "Date": "Dato",
      "Time": "Tid",
      "Confirm": "Bekræft",
      "Booking confirmed!": "Booking bekræftet!",
      
      // Dashboard - Payment Info
      "Payment Information": "Betalingsinformation",
      "Please transfer the amount before your lesson. Use your name as payment reference.": "Overfør venligst beløbet før din lektion. Brug dit navn som betalingsreference.",
      
      // User approval
      "Your account is awaiting approval": "Din konto afventer godkendelse. Kontakt venligst admin.",
      "Account pending approval": "Din konto afventer godkendelse. Du vil kunne booke lektioner, når du er godkendt af en administrator.",
      "Account Awaiting Approval": "Konto Afventer Godkendelse",
      "Your account is currently awaiting admin approval. You will be able to book lessons once your account has been approved. We will notify you by email when your account is ready.": "Din konto afventer i øjeblikket admin godkendelse. Du vil kunne booke lektioner, når din konto er blevet godkendt. Vi giver dig besked via email, når din konto er klar.",
      
      // Backup page
      "Database Backup": "Database Backup",
      "Download or restore your database": "Download eller gendan din database",
      "Back to Admin": "Tilbage til Admin",
      "Download Backup": "Download Backup",
      "Download a complete backup of all your data as a JSON file": "Download en komplet backup af alle dine data som en JSON fil",
      "Backup includes": "Backup inkluderer",
      "Users": "Brugere",
      "Bookings": "Bookinger",
      "Availability": "Tilgængelighed",
      "Weekend Courses": "Weekend Kurser",
      "Theory Clinics": "Teori Clinics",
      "Settings": "Indstillinger",
      "Admin Events": "Admin Begivenheder",
      "Downloading...": "Downloader...",
      "Backup downloaded successfully": "Backup downloadet",
      "Failed to download backup": "Kunne ikke downloade backup",
      "Restore Backup": "Gendan Backup",
      "Upload a backup file to restore your data": "Upload en backup fil for at gendanne dine data",
      "Note": "Bemærk",
      "Restore will only add missing data. Existing records will not be overwritten or deleted.": "Gendannelse tilføjer kun manglende data. Eksisterende data bliver ikke overskrevet eller slettet.",
      "Select Backup File": "Vælg Backup Fil",
      "Restoring...": "Gendanner...",
      "Please select a JSON file": "Vælg venligst en JSON fil",
      "Invalid backup file format": "Ugyldig backup fil format",
      "Invalid JSON file": "Ugyldig JSON fil",
      "Failed to restore backup": "Kunne ikke gendanne backup",
      "Restore completed successfully": "Gendannelse fuldført",
      "Restore completed": "Gendannelse fuldført",
      "Backup date": "Backup dato",
      "Restored records": "Gendannede data",
      "Yes": "Ja",
      "No": "Nej",
      "Loading...": "Indlæser...",
      "Automatic Backups": "Automatiske Backups",
      "Daily backups at 15:00 - kept for 7 days": "Daglige backups kl. 15:00 - gemmes i 7 dage",
      "Refresh": "Opdater",
      "No automatic backups yet": "Ingen automatiske backups endnu",
      "First backup will be created at 15:00": "Første backup oprettes kl. 15:00",
      "Latest": "Nyeste",
      "Download": "Download",
      
      // Customer Dashboard
      "Welcome back": "Velkommen tilbage",
      "My Bookings": "Mine Bookinger",
      "Profile": "Profil",
      "Payment Methods": "Betalingsmetoder",
      "Upcoming": "Kommende",
      "Past": "Tidligere",
      "All": "Alle",
      "Loading bookings...": "Indlæser bookinger...",
      "You don't have any upcoming bookings.": "Du har ingen kommende bookinger.",
      "You don't have any past bookings yet.": "Du har ingen tidligere bookinger endnu.",
      "You don't have any bookings yet.": "Du har ingen bookinger endnu.",
      "Book a Lesson": "Book en Lektion",
      "Cancelled": "Annulleret",
      "Paid": "Betalt",
      "Payment Pending": "Afventer Betaling",
      "Pay on arrival": "Betal ved ankomst",
      "View Receipt": "Se Kvittering",
      "Cancel Booking": "Annuller Booking",
      "Are you sure you want to cancel this booking?": "Er du sikker på, at du vil annullere denne booking?",
      "Booking cancelled successfully": "Booking annulleret",
      "Failed to cancel booking": "Kunne ikke annullere booking",
      "Failed to load bookings": "Kunne ikke indlæse bookinger",
      "Failed to load receipt": "Kunne ikke indlæse kvittering",
      "Profile Settings": "Profilindstillinger",
      "Email cannot be changed": "Email kan ikke ændres",
      "Name": "Navn",
      "Saving...": "Gemmer...",
      "Save Changes": "Gem Ændringer",
      "Profile updated successfully": "Profil opdateret",
      "Failed to update profile": "Kunne ikke opdatere profil",
      
      // Get as App tab
      "Get as App": "Få siden som app",
      "Add JCP Lessons to your home screen": "Tilføj JCP Lessons til din startskærm",
      "app_description": "I stedet for at skulle åbne hjemmesiden hver gang, kan du få JCP Lessons ned på din telefon som en app. Dette giver dig hurtig adgang til at booke lektioner direkte fra din startskærm.",
      "How to install on iPhone": "Sådan installerer du på iPhone",
      "Step 1": "Trin 1",
      "Step 2": "Trin 2",
      "Step 3": "Trin 3",
      "Step 4": "Trin 4",
      "Open the website in Safari on your iPhone": "Åbn hjemmesiden i Safari på din iPhone",
      "Tap the Share button": "Tryk på Del-knappen",
      "Select \"Add to Home Screen\"": "Vælg \"Føj til hjemmeskærm\"",
      "The icon will appear with \"JCP LESSONS\" text": "Ikonet vises med \"JCP LESSONS\" teksten",
      "Tap the link and follow the 4 steps above": "Tryk på linket og udfør de 4 punkter ovenfor",
      "Android users can also add to home screen via Chrome menu": "Android-brugere kan også tilføje til hjemmeskærm via Chrome-menuen",
      
      // Admin Dashboard
      "Admin Dashboard": "Admin Dashboard",
      "Select an area to manage": "Vælg et område for at administrere",
      "Calendar": "Kalender",
      "Plan": "Planlæg",
      "User Management": "Brugeradministration",
      "Service Visibility": "Tjenester Synlighed",
      "Backup": "Backup",
      "Upcoming Bookings (7 days)": "Kommende Bookinger (7 dage)",
      "bookings": "bookinger",
      "No bookings in the next 7 days": "Ingen bookinger de næste 7 dage",
      "Today": "I dag",
      "Tomorrow": "I morgen",
      "Send Reminder": "Send Påmindelse",
      "Reminder": "Påmindelse",
      "Sending...": "Sender...",
      "Reminder sent to": "Påmindelse sendt til",
      "Could not send reminder": "Kunne ikke sende påmindelse",
      "View All Bookings": "Se Alle Bookinger",
      
      // Admin Bookings
      "Manage Bookings": "Administrer Bookinger",
      "Back to Admin Dashboard": "Tilbage til Admin Dashboard",
      "total": "total",
      "awaiting payment": "afventer betaling",
      "No bookings yet.": "Ingen bookinger endnu.",
      "booking": "booking",
      "Mark as paid?": "Marker som betalt?",
      "Mark as paid? (Greven booking will be deleted after payment)": "Marker som betalt? (Heiden-booking slettes automatisk efter betaling)",
      "Booking marked as paid and deleted": "Booking markeret som betalt og slettet",
      "Booking marked as paid": "Booking markeret som betalt",
      "Could not update payment": "Kunne ikke opdatere betaling",
      "Booking cancelled": "Booking annulleret",
      "Could not cancel booking": "Kunne ikke annullere booking",
      "Pivo Online": "Pivo Online",
      "Live in Greven": "Live i Heiden",
      
      // Admin Availability
      "Manage Availability": "Administrer Tilgængelighed",
      "Create and manage instructor availability": "Opret og administrer instruktørers tilgængelighed",
      "Add Availability": "Tilføj Tilgængelighed",
      "No availability slots created yet.": "Ingen tilgængelighedsslots oprettet endnu.",
      "Click Add Availability to create new time slots for bookings.": "Klik på Tilføj Tilgængelighed for at oprette nye tidsslots til bookinger.",
      "date": "dato",
      "dates": "datoer",
      "slots": "slots",
      "Are you sure you want to delete availability for": "Er du sikker på, at du vil slette tilgængelighed for",
      "Availability deleted": "Tilgængelighed slettet",
      "Could not delete availability": "Kunne ikke slette tilgængelighed",
      "Copy to next weeks": "Kopier til næste uger",
      "Edit": "Rediger",
      "Delete": "Slet",
      "date(s) copied!": "dato(er) kopieret!",
      "date(s) skipped (already exists)": "dato(er) sprunget over (findes allerede)",
      "Could not copy availability": "Kunne ikke kopiere tilgængelighed"
    }
  },
  de: {
    translation: {
      // Homepage
      "Book Teaching at JCP": "Unterricht bei JCP buchen",
      "Experience world-class training": "Erleben Sie Weltklasse-Unterricht mit Champion-Reitern",
      "World-class training": "Weltklasse-Training für jeden Reiter und jedes Niveau. Bekannt für außergewöhnliche Lehrfähigkeiten mit einer Philosophie, die auf Gleichheit, Respekt und Inklusion basiert.",
      "Rising star": "Aufstrebender Stern im skandinavischen Reitsport. Unterrichtet mit Klarheit, Energie und moderner Perspektive. Nehmen Sie jeden Dienstag an persönlichen Reitstunden teil.",
      "Learn more": "Unterricht Buchen",
      "Home": "Startseite",
      
      // Julie Options Page
      "Choose Your Training Type": "Wählen Sie Ihre Trainingsart",
      "Select how you'd like to train": "Wählen Sie, wie Sie mit Julie Christiansen trainieren möchten",
      "Pivo Live Lesson": "Pivo Live Lektion",
      "Remote Teaching - Wednesdays": "Fernunterricht - Mittwochs",
      "Pivo description": "Persönliche Online-Trainingssitzungen per Videoanruf. Lernen Sie von überall aus mit Julie als Ihrem Remote-Guide. Perfekt für Reiter, die Weltklasse-Coaching von ihrem eigenen Standort aus wünschen.",
      "On-Site Training": "Live in Heiden",
      "New address note": "(neue Adresse)",
      "Live at JC-P Facility - Wednesdays": "Mittwochs",
      "On-Site description": "Trainieren Sie persönlich in unserer schönen, hellen Reithalle. Direkte praktische Anleitung mit Julie in einer professionellen Trainingsumgebung.",
      "Price per lesson": "Preis: €{{price}} pro Reitstunde",
      "Available daytime and evening": "Verfügbar: Mittwochs - Tagsüber und abends",
      "Greven session info": "Info: Reitstunden dauern 40 Minuten.",
      "Weekend Clinic": "Wochenend Kurs",
      "At Your Stable or Club": "Bei Ihrem Stall oder Verein",
      "Weekend description": "Buchen Sie Julie für einen intensiven 2-4 Tage Kurs in Ihrer eigenen Einrichtung. Maximal 10 Reiter. Maßgeschneidertes Programm mit Fokus auf Pferd-Reiter-Partnerschaften.",
      "Weekend Course in Greven": "Wochenend Kurs",
      "Here in Greven": "Hier in Heiden",
      "Weekend Greven description": "Wir bieten auch gelegentlich 2-3 Tage Kurse in unserem Stall in Heiden an. Sehen Sie die verfügbaren Termine für 2026.",
      "Theorie Clinic": "Theorie Clinic",
      "Theoretical Workshops - Online or On-Site": "Theoretische Workshops - Online oder vor Ort",
      "Theorie Clinic description": "Buchen Sie eine theoretische Clinic zu einem Thema Ihrer Wahl. Online Abendtermine oder persönlich bei Ihnen im Stall oder Verein.",
      
      // Booking Pages
      "Pivo Live Lesson with Julie": "Pivo Live Lektion mit Julie",
      "Remote teaching - Available Wednesdays": "Fernunterricht - Verfügbar mittwochs",
      "On-Site Training at JC-P": "Unterricht mit Julie",
      "Train live in our beautiful indoor arena - Wednesdays": "Live Sessions in Heiden - Jeden Mittwoch",
      "Teaching with Óskar": "Unterricht mit Óskar",
      "Live sessions at JC-P - Every Tuesday": "Live-Sessions in Heiden - Jeden Dienstag",
      "Weekend Clinic with Julie": "Wochenend Kurs mit Julie",
      "Host Julie at your stable or club for an intensive clinic": "Buchen Sie Julie in Ihrem Stall oder Verein für einen intensiven Kurs",
      
      // Calendar
      "Colored dates are available for booking": "Farbige Termine sind für die Buchung verfügbar",
      "Select a date and time": "Datum und Uhrzeit wählen",
      
      // Information Sections
      "About Pivo Live Lessons": "Über Pivo Live Lektionen",
      "About On-Site Training": "Über Training vor Ort",
      "About Óskar Erik Kristjánsson": "Über Óskar Erik Kristjánsson",
      "About Weekend Clinics": "Über Wochenend Kursen",
      
      // Pivo Info
      "Train remotely with Julie": "Trainieren Sie aus der Ferne mit Julie Christiansen durch Live-Video-Reitstunden. Mit Pivo-Technologie kann Julie Ihr Training in Echtzeit von überall auf der Welt beobachten und anleiten.",
      "About Julie": "Über Julie:",
      "3x World Champion": "3x Weltmeister",
      "3x Nordic Champion": "3x Nordischer Meister",
      "25x Danish Champion": "25x Dänischer Meister",
      "Renowned for exceptional teaching": "Bekannt für außergewöhnliche Lehrfähigkeiten für alle Niveaus",
      "Sessions last 60 minutes": "Reitstunden dauern 40 Minuten und sind auf Ihre individuellen Ziele und Ihr Können zugeschnitten.",
      "Oscar price": "Preis: €30 pro Lektion",
      "Online payment required": "(Online-Zahlung erforderlich)",
      "Pay on-site": "(Vor Ort bezahlen)",
      "Available Wednesdays": "Verfügbar: Mittwochs",
      "Available Tuesday afternoons": "Verfügbar: Dienstagnachmittage und -abende",
      
      // On-Site Info
      "Train in person with Julie": "Trainieren Sie persönlich mit Julie Christiansen in unserer schönen, hellen Reithalle bei JC-P. Erleben Sie direkte praktische Anleitung in einer professionellen Trainingsumgebung.",
      "Exceptional didactic skills": "Außergewöhnliche didaktische Fähigkeiten für alle Niveaus von Anfängern bis Top-Konkurrenten",
      "Julie's philosophy": "Julies Philosophie basiert auf Gleichheit, Respekt und Inklusion. Jeder Schüler erhält aufmerksame Betreuung unabhängig von Hintergrund oder Zielen. Reitstunden sind auf Ihre individuelle Pferd-Reiter-Partnerschaft zugeschnitten.",
      
      // Oscar Info
      "Rising star in Scandinavian": "Aufstrebender Stern im skandinavischen Reitsport",
      "Championships": "Meisterschaften:",
      "2x Nordic Champion": "2x Nordischer Meister",
      "Winner of German Youth Championships": "3x Gewinner der Deutschen Jugendmeisterschaften (DJIM)",
      "10x Danish Champion": "10x Dänischer Meister",
      "Oscar teaches with clarity": "Óskar unterrichtet mit Klarheit, Energie und einer modernen Perspektive. Er bringt Wettkampferfahrung und frische Motivation in jede Lektion und ist damit eines der aufregendsten jungen Talente im skandinavischen Reittraining.",
      "Join Oscar for sessions": "Nehmen Sie an Óskars persönlichen Reitstunden in unserer schönen, hellen Reithalle teil. Die Reitstunden sind auf Ihre individuellen Ziele und Ihr Können zugeschnitten.",
      "Oscar session info": "Info: Reitstunden dauern 40 Minuten.",
      
      // Weekend Clinic Info
      "Julie Christiansen - accomplished": "Julie Christiansen - eine der erfolgreichsten Reiterinnen und Trainerinnen Skandinaviens:",
      "Host Julie intensive": "Buchen Sie Julie für einen intensiven 2-4 Tage Kurs direkt in Ihrem eigenen Stall oder Verein. Ihr warmer, leidenschaftlicher Ansatz schafft einen motivierenden Raum, in dem echter Fortschritt entsteht.",
      "Clinic Details": "Kurs Details:",
      "Duration minimum 2 days": "Dauer: Mindestens 2 Tage, bis zu 4 aufeinanderfolgende Tage",
      "Maximum 10 riders": "Maximale Teilnehmer: 10 Reiter",
      "Price per day": "Preis: €{{price}} pro Tag",
      "Includes travel costs": "Inkludiert: Training, Reisekosten, Flugkosten",
      "Additional accommodation": "Zusätzlich: Unterkunft und Verpflegung für Julie",
      "Important": "Wichtig:",
      "Book minimum 2 days": "Buchen Sie mindestens 2 Tage (jeder Tag muss gebucht werden)",
      "Cancellation 1 month": "Stornierung bis 1 Monat vor Kursbeginn möglich",
      "Program tailored": "Programm kann auf die Bedürfnisse Ihrer Gruppe zugeschnitten werden",
      "After submitting request": "Nach Einreichung Ihrer Anfrage werden wir Sie kontaktieren, um die Verfügbarkeit zu bestätigen und das spezifische Programm und die Arrangements zu besprechen.",
      
      // Form
      "Select Date": "Datum Wählen",
      "Available Times": "Verfügbare Zeiten",
      "Select date in calendar": "Bitte wählen Sie ein Datum im Kalender",
      "No available time slots": "Keine verfügbaren Zeitfenster für dieses Datum",
      "Your Information": "Ihre Informationen",
      "Full Name": "Vollständiger Name",
      "Email": "E-Mail",
      "Phone": "Telefon",
      "Confirm Booking": "Buchung Bestätigen",
      "Book & Pay Online": "Buchen & Online Bezahlen",
      "Processing": "Verarbeitung...",
      "Submitting": "Wird gesendet...",
      
      // Weekend Form
      "Number of Days": "Anzahl der Tage (Mindestens 2)",
      "Days": "Tage",
      "Plus accommodation": "+ Unterkunft & Verpflegung",
      "Total": "Gesamt: €{total}",
      "Stable/Club Name": "Stall-/Vereinsname & Standort",
      "Where clinic held": "Wo wird der Kurs stattfinden?",
      "Request Weekend Clinic": "Wochenendkurs Anfragen",
      "Request only": "Dies ist nur eine Anfrage. Wir werden Sie kontaktieren, um Termine zu bestätigen und Details zu finalisieren.",
      
      // External Weekend Course Page
      "External Weekend Courses": "Externe Wochenendkurse",
      "Host Julie at your stable": "Laden Sie Julie in Ihren Stall oder Verein zu einem intensiven Kurs ein",
      "Date flexibility notice": "Wichtig: Terminflexibilität",
      "Date flexibility description": "Wir versuchen, Ihre Terminwünsche zu berücksichtigen, können dies aber nicht garantieren. Daher ist es gut, ein alternatives Datum anzugeben.",
      "About Weekend Courses": "Über Wochenendkurse",
      "Weekend course intro": "Eine fantastische Gelegenheit, von einer der Besten im Sport in einer privaten und fokussierten Umgebung zu lernen.",
      "Course Details": "Kursdetails",
      "Duration": "Dauer",
      "Min 2 max 4 days": "Minimum 2, Maximum 4 Tage",
      "Maximum": "Maximum",
      "riders": "Reiter",
      "Price per day": "Preis pro Tag",
      "includes travel": "inklusive Reisekosten",
      "Extra costs": "Zusätzliche Kosten",
      "Accommodation and meals": "Unterkunft + Verpflegung",
      "Request Course": "Kurs Anfragen",
      "Number of Days": "Anzahl der Tage",
      "You must be logged in": "Sie müssen eingeloggt sein",
      "Please fill in name/stable and address": "Bitte füllen Sie Name/Stall und Adresse aus",
      "Please select a date period": "Bitte wählen Sie einen Zeitraum",
      "Please select which days": "Bitte wählen Sie welche Tage des Zeitraums",
      "Request sent successfully": "Anfrage gesendet! Wir werden Sie bald mit möglichen Terminen kontaktieren.",
      "Could not send request": "Anfrage konnte nicht gesendet werden",
      "Name/Stable/Club": "Name/Stall/Verein",
      "Your name, stable or club": "Ihr Name, Stall oder Verein",
      "Address": "Adresse",
      "Course location address": "Adresse des Kursorts",
      "Preferred Date": "Gewünschtes Datum",
      "Loading dates": "Termine werden geladen",
      "No dates available": "Derzeit keine Termine verfügbar. Bitte schauen Sie später noch einmal vorbei oder kontaktieren Sie uns direkt.",
      "Which days": "Welche Tage des Zeitraums?",
      "Which days for alternative": "Welche Tage für alternatives Datum?",
      "First 2 days": "Erste 2 Tage",
      "Last 2 days": "Letzte 2 Tage",
      "First 3 days": "Erste 3 Tage",
      "Last 3 days": "Letzte 3 Tage",
      "All 4 days": "Alle 4 Tage",
      "Alternative Date": "Alternatives Datum",
      "optional": "optional",
      "No alternative": "Keine Alternative",
      "Course Type": "Kursart",
      "Single Course": "Einzelkurs",
      "One-time event": "Einmalige Veranstaltung",
      "Course Series": "Kursreihe",
      "Multiple throughout year": "Mehrere Kurse über das Jahr",
      "Additional Information": "Zusätzliche Informationen",
      "Additional info description": "Teilen Sie besondere Wünsche, Teilnehmerzahl oder andere relevante Informationen mit.",
      "Additional info placeholder": "Besondere Wünsche, Teilnehmerzahl oder andere Informationen...",
      "Not enough days available": "Nicht genügend Tage für Ihre Auswahl verfügbar",
      "No day options available for this period": "Keine Tagesoptionen für diesen Zeitraum verfügbar",
      "Try selecting fewer days or another period": "Versuchen Sie, weniger Tage oder einen anderen Zeitraum zu wählen",
      "Only available": "Nur verfügbar",
      "days available": "Tage verfügbar",
      "Sending": "Wird gesendet",
      "Send Request": "Anfrage Senden",
      
      // Weekend Greven Page
      "Weekend Course in Greven with Julie": "Wochenend Kurs in Heiden mit Julie",
      "Join us for intensive courses at our stable": "Nehmen Sie an intensiven Kursen in unserem Stall teil",
      "About Weekend Courses in Greven": "Über Wochenend Kurse in Heiden",
      "Weekend Greven intensive text": "Wir bieten gelegentlich intensive 2-3 Tage Kurse direkt bei uns im Stall in Heiden an. Ihr warmer, leidenschaftlicher Ansatz schafft einen motivierenden Raum, in dem echter Fortschritt entsteht.",
      "Duration 2-3 days": "Dauer: 2-3 Tage",
      "Location": "Ort",
      "Our stable in Greven": "Unser Stall in Heiden",
      "Specific dates available for 2026": "Spezifische Termine verfügbar für 2026",
      "Select from available dates": "Wählen Sie aus verfügbaren Terminen",
      "Request Course in Greven": "Kurs in Heiden Anfragen",
      "Weekend Greven request submitted": "Kursanfrage gesendet! Wir werden Sie kontaktieren, um die Verfügbarkeit zu bestätigen und Details zu besprechen.",
      
      // Theorie Clinic Page
      "Theorie Clinic with Julie": "Theorie Clinic mit Julie",
      "Book theoretical workshops on equestrian topics": "Buchen Sie theoretische Workshops zu Reitthemen",
      "About Theorie Clinics": "Über Theorie Clinics",
      "Theorie Clinic experience text": "Mit großer Erfahrung im Halten von theoretischen Clinics biete ich Workshops zu verschiedenen Reitthemen an. Ich habe zahlreiche Live-Clinics und große Vorträge in vielen verschiedenen Ländern gehalten, sowohl online als auch persönlich.",
      "Clinic Options": "Clinic Optionen",
      "Online evening sessions": "Online Tag oder Abendtermine",
      "On-site workshops at your stable or club": "Vor Ort Workshops in Ihrem Stall oder Verein",
      "Flexible duration": "Flexible Dauer",
      "Evening, day or multi-day": "Abend, Tag oder mehrtägig",
      "Topics of your choice": "Themen nach Ihrer Wahl",
      "Theorie Clinic details text": "Wählen Sie ein Thema, das Sie interessiert, und ich erstelle eine maßgeschneiderte Clinic. Ob Online-Abendtermin oder persönlich bei Ihnen - ich passe mich Ihren Bedürfnissen an.",
      "Let us know interested": "Lassen Sie uns wissen, woran Sie interessiert sind.",
      "Request heading": "Anfrage",
      "Select dates that suit": "Wählen Sie ein oder mehrere Termine, die Ihnen passen.",
      "Select your preferred date": "Wählen Sie Ihr bevorzugtes Datum",
      "Clinic Type": "Clinic Art",
      "Online": "Online",
      "On-Site": "Vor Ort",
      "Preferred Duration": "Bevorzugte Dauer",
      "Evening": "Abend",
      "Full Day": "Ganzer Tag",
      "Multi-Day": "Mehrtägig",
      "Topic / Theme": "Thema",
      "What topic would you like to cover?": "Welches Thema möchten Sie behandeln?",
      "Stable/Club name and location": "Stall-/Vereinsname und Standort",
      "Additional Notes": "Zusätzliche Anmerkungen",
      "Any special requests or questions": "Besondere Wünsche oder Fragen",
      "Request Theorie Clinic": "Theorie Clinic Anfragen",
      "Theorie Clinic request submitted": "Theorie Clinic Anfrage gesendet! Wir werden Sie kontaktieren, um Details zu besprechen.",
      "Please select a date": "Bitte wählen Sie ein Datum",
      "Please fill all required fields": "Bitte füllen Sie alle erforderlichen Felder aus",
      "Please provide location for on-site clinic": "Bitte geben Sie den Ort für die Vor-Ort-Clinic an",
      
      // Messages
      "Please select date time": "Bitte wählen Sie Datum und Uhrzeit",
      "Please fill all fields": "Bitte füllen Sie alle Felder aus",
      "Booking confirmed message": "Buchung bestätigt! Bezahlen Sie vor Ort bei Ihrer Reitstunde.",
      "Weekend request submitted": "Wochenendkurs-Anfrage gesendet! Wir werden Sie kontaktieren, um die Verfügbarkeit zu bestätigen und Details zu besprechen.",
      "Failed to create booking": "Buchung konnte nicht erstellt werden",
      "Failed to submit request": "Anfrage konnte nicht gesendet werden",
      "Please select start date": "Bitte wählen Sie ein Startdatum",
      
      // Booking confirmation
      "Confirm booking": "Buchung bestätigen",
      "Date": "Datum",
      "Time": "Zeit",
      "Confirm": "Bestätigen",
      "Booking confirmed!": "Buchung bestätigt!",
      
      // Dashboard - Payment Info
      "Payment Information": "Zahlungsinformationen",
      "Please transfer the amount before your lesson. Use your name as payment reference.": "Bitte überweisen Sie den Betrag vor Ihrer Reitstunde. Verwenden Sie Ihren Namen als Zahlungsreferenz.",
      
      // User approval
      "Your account is awaiting approval": "Ihr Konto wartet auf Genehmigung. Bitte kontaktieren Sie den Administrator.",
      "Account pending approval": "Ihr Konto wartet auf Genehmigung. Sie können Reitstunden buchen, sobald Sie von einem Administrator genehmigt wurden.",
      "Account Awaiting Approval": "Konto Wartet auf Genehmigung",
      "Your account is currently awaiting admin approval. You will be able to book lessons once your account has been approved. We will notify you by email when your account is ready.": "Ihr Konto wartet derzeit auf Admin-Genehmigung. Sie können Reitstunden buchen, sobald Ihr Konto genehmigt wurde. Wir benachrichtigen Sie per E-Mail, wenn Ihr Konto bereit ist.",
      
      // Backup page
      "Database Backup": "Datenbank Backup",
      "Download or restore your database": "Datenbank herunterladen oder wiederherstellen",
      "Back to Admin": "Zurück zu Admin",
      "Download Backup": "Backup Herunterladen",
      "Download a complete backup of all your data as a JSON file": "Laden Sie ein komplettes Backup aller Ihrer Daten als JSON-Datei herunter",
      "Backup includes": "Backup enthält",
      "Users": "Benutzer",
      "Bookings": "Buchungen",
      "Availability": "Verfügbarkeit",
      "Weekend Courses": "Wochenend Kurse",
      "Theory Clinics": "Theorie Clinics",
      "Settings": "Einstellungen",
      "Admin Events": "Admin Ereignisse",
      "Downloading...": "Wird heruntergeladen...",
      "Backup downloaded successfully": "Backup heruntergeladen",
      "Failed to download backup": "Backup konnte nicht heruntergeladen werden",
      "Restore Backup": "Backup Wiederherstellen",
      "Upload a backup file to restore your data": "Laden Sie eine Backup-Datei hoch, um Ihre Daten wiederherzustellen",
      "Note": "Hinweis",
      "Restore will only add missing data. Existing records will not be overwritten or deleted.": "Die Wiederherstellung fügt nur fehlende Daten hinzu. Bestehende Daten werden nicht überschrieben oder gelöscht.",
      "Select Backup File": "Backup-Datei Auswählen",
      "Restoring...": "Wird wiederhergestellt...",
      "Please select a JSON file": "Bitte wählen Sie eine JSON-Datei",
      "Invalid backup file format": "Ungültiges Backup-Dateiformat",
      "Invalid JSON file": "Ungültige JSON-Datei",
      "Failed to restore backup": "Backup konnte nicht wiederhergestellt werden",
      "Restore completed successfully": "Wiederherstellung abgeschlossen",
      "Restore completed": "Wiederherstellung abgeschlossen",
      "Backup date": "Backup-Datum",
      "Restored records": "Wiederhergestellte Daten",
      "Yes": "Ja",
      "No": "Nein",
      "Loading...": "Wird geladen...",
      "Automatic Backups": "Automatische Backups",
      "Daily backups at 15:00 - kept for 7 days": "Tägliche Backups um 15:00 - 7 Tage aufbewahrt",
      "Refresh": "Aktualisieren",
      "No automatic backups yet": "Noch keine automatischen Backups",
      "First backup will be created at 15:00": "Erstes Backup wird um 15:00 erstellt",
      "Latest": "Neueste",
      "Download": "Herunterladen",
      
      // Customer Dashboard
      "Welcome back": "Willkommen zurück",
      "My Bookings": "Meine Buchungen",
      "Profile": "Profil",
      "Payment Methods": "Zahlungsmethoden",
      "Upcoming": "Kommende",
      "Past": "Vergangene",
      "All": "Alle",
      "Loading bookings...": "Buchungen werden geladen...",
      "You don't have any upcoming bookings.": "Sie haben keine kommenden Buchungen.",
      "You don't have any past bookings yet.": "Sie haben noch keine vergangenen Buchungen.",
      "You don't have any bookings yet.": "Sie haben noch keine Buchungen.",
      "Book a Lesson": "Reitstunde Buchen",
      "Cancelled": "Storniert",
      "Paid": "Bezahlt",
      "Payment Pending": "Zahlung ausstehend",
      "Pay on arrival": "Vor Ort bezahlen",
      "View Receipt": "Quittung Anzeigen",
      "Cancel Booking": "Buchung Stornieren",
      "Are you sure you want to cancel this booking?": "Sind Sie sicher, dass Sie diese Buchung stornieren möchten?",
      "Booking cancelled successfully": "Buchung storniert",
      "Failed to cancel booking": "Buchung konnte nicht storniert werden",
      "Failed to load bookings": "Buchungen konnten nicht geladen werden",
      "Failed to load receipt": "Quittung konnte nicht geladen werden",
      "Profile Settings": "Profileinstellungen",
      "Email cannot be changed": "E-Mail kann nicht geändert werden",
      "Name": "Name",
      "Saving...": "Wird gespeichert...",
      "Save Changes": "Änderungen Speichern",
      "Profile updated successfully": "Profil aktualisiert",
      "Failed to update profile": "Profil konnte nicht aktualisiert werden",
      
      // Get as App tab
      "Get as App": "Als App installieren",
      "Add JCP Lessons to your home screen": "JCP Lessons zum Startbildschirm hinzufügen",
      "app_description": "Anstatt jedes Mal die Website zu öffnen, können Sie JCP Lessons als App auf Ihrem Telefon installieren. So haben Sie schnellen Zugriff, um Reitstunden direkt von Ihrem Startbildschirm aus zu buchen.",
      "How to install on iPhone": "So installieren Sie auf dem iPhone",
      "Step 1": "Schritt 1",
      "Step 2": "Schritt 2",
      "Step 3": "Schritt 3",
      "Step 4": "Schritt 4",
      "Open the website in Safari on your iPhone": "Öffnen Sie die Website in Safari auf Ihrem iPhone",
      "Tap the Share button": "Tippen Sie auf die Teilen-Taste",
      "Select \"Add to Home Screen\"": "Wählen Sie \"Zum Home-Bildschirm\"",
      "The icon will appear with \"JCP LESSONS\" text": "Das Symbol erscheint mit dem Text \"JCP LESSONS\"",
      "Tap the link and follow the 4 steps above": "Tippen Sie auf den Link und folgen Sie den 4 Schritten oben",
      "Android users can also add to home screen via Chrome menu": "Android-Benutzer können auch über das Chrome-Menü zum Startbildschirm hinzufügen",
      
      // Admin Dashboard
      "Admin Dashboard": "Admin Dashboard",
      "Select an area to manage": "Wählen Sie einen Bereich zum Verwalten",
      "Calendar": "Kalender",
      "Plan": "Planung",
      "User Management": "Benutzerverwaltung",
      "Service Visibility": "Dienste Sichtbarkeit",
      "Backup": "Backup",
      "Upcoming Bookings (7 days)": "Kommende Buchungen (7 Tage)",
      "bookings": "Buchungen",
      "No bookings in the next 7 days": "Keine Buchungen in den nächsten 7 Tagen",
      "Today": "Heute",
      "Tomorrow": "Morgen",
      "Send Reminder": "Erinnerung Senden",
      "Reminder": "Erinnerung",
      "Sending...": "Wird gesendet...",
      "Reminder sent to": "Erinnerung gesendet an",
      "Could not send reminder": "Erinnerung konnte nicht gesendet werden",
      "View All Bookings": "Alle Buchungen Anzeigen",
      
      // Admin Bookings
      "Manage Bookings": "Buchungen Verwalten",
      "Back to Admin Dashboard": "Zurück zum Admin Dashboard",
      "total": "gesamt",
      "awaiting payment": "Zahlung ausstehend",
      "No bookings yet.": "Noch keine Buchungen.",
      "booking": "Buchung",
      "Mark as paid?": "Als bezahlt markieren?",
      "Mark as paid? (Greven booking will be deleted after payment)": "Als bezahlt markieren? (Heiden-Buchung wird nach Zahlung gelöscht)",
      "Booking marked as paid and deleted": "Buchung als bezahlt markiert und gelöscht",
      "Booking marked as paid": "Buchung als bezahlt markiert",
      "Could not update payment": "Zahlung konnte nicht aktualisiert werden",
      "Booking cancelled": "Buchung storniert",
      "Could not cancel booking": "Buchung konnte nicht storniert werden",
      "Pivo Online": "Pivo Online",
      "Live in Greven": "Live in Heiden",
      
      // Admin Availability
      "Manage Availability": "Verfügbarkeit Verwalten",
      "Create and manage instructor availability": "Trainer-Verfügbarkeit erstellen und verwalten",
      "Add Availability": "Verfügbarkeit Hinzufügen",
      "No availability slots created yet.": "Noch keine Verfügbarkeitsslots erstellt.",
      "Click Add Availability to create new time slots for bookings.": "Klicken Sie auf Verfügbarkeit Hinzufügen, um neue Zeitfenster zu erstellen.",
      "date": "Datum",
      "dates": "Termine",
      "slots": "Slots",
      "Are you sure you want to delete availability for": "Sind Sie sicher, dass Sie die Verfügbarkeit löschen möchten für",
      "Availability deleted": "Verfügbarkeit gelöscht",
      "Could not delete availability": "Verfügbarkeit konnte nicht gelöscht werden",
      "Copy to next weeks": "In nächste Wochen kopieren",
      "Edit": "Bearbeiten",
      "Delete": "Löschen",
      "date(s) copied!": "Datum/Termine kopiert!",
      "date(s) skipped (already exists)": "Datum/Termine übersprungen (bereits vorhanden)",
      "Could not copy availability": "Verfügbarkeit konnte nicht kopiert werden"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de',
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
